module.exports = __webpack_public_path__ + "static/media/sidebar-button.e17ae5cc.png";